// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_ReserveSettingsInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * AiCredits_ReserveSettingsInput — body for POST /ai/credits/reserve-settings.
 *
 * The two token assumptions behind the admission hold. The reserve prices a
 * WORST-CASE turn before the stream opens, so these decide how much a franchise
 * must have available to start a conversation:
 *
 *     hold = priceReserve(hit=0, miss=input_miss_tokens, out=output_tokens)
 *
 * They were hardcoded in two controllers (49152 / 4096) until 2026-08-21. That
 * became untenable once the peg went per-franchise: the hold scales with the
 * peg, so a franchise burning 10x faster needed 10x the balance to open any
 * conversation at all.
 *
 * Both are optional — POST either, or both. Omitting one leaves it unchanged,
 * so the console can save one field without having to echo the other back.
 *
 * Bounds are sanity rails, not policy: a zero or negative cap would disable the
 * overdraft guard outright, and a cap far above the model's real ceiling just
 * recreates the problem this knob exists to solve.
 */
import { registerContract } from './validate'

export interface AiCredits_ReserveSettingsInput {
output_tokens?: number
input_miss_tokens?: number
}

registerContract('AiCredits_ReserveSettingsInput', {
  output_tokens:     { type: 'number',  required: false },
  input_miss_tokens: { type: 'number',  required: false },
})
